import { API_BASE } from "@/constants/api";
import { parseUkAddressParts, type UkAddressParts } from "@/utils/quoteMapper";

export type EnergyPlanHandoff = {
  email?: string;
  first_name?: string;
  property_id: string;
  partner_id: string;
  agency_name?: string | null;
  listing_id?: string | null;
  snapshot?: {
    score?: {
      overall_score?: number | null;
      helio_confidence?: number | null;
      address?: string | null;
    };
  };
};

export type EnergyPlanPrefill = {
  propertyId: string;
  partnerId: string;
  agencyName: string;
  score: string;
  addressLine: string;
  address: UkAddressParts | null;
};

export function looksLikeUprn(value: string): boolean {
  return /^\d{5,}$/.test(value.trim());
}

export function parseHandoffPrefill(handoff: EnergyPlanHandoff): EnergyPlanPrefill {
  const addressLine = handoff.snapshot?.score?.address?.trim() || "";
  const parsed = addressLine ? parseUkAddressParts(addressLine) : null;
  const address = parsed && (parsed.address1 || parsed.postcode) ? parsed : null;
  const overall = handoff.snapshot?.score?.overall_score;
  const score = overall == null ? "" : String(overall);

  if (address && looksLikeUprn(handoff.property_id)) {
    address.uprn = handoff.property_id;
  }

  return {
    propertyId: handoff.property_id,
    partnerId: handoff.partner_id,
    agencyName: handoff.agency_name?.trim() || "",
    score,
    addressLine,
    address,
  };
}

export function buildQuoteUrl(prefill: EnergyPlanPrefill): string {
  const params = new URLSearchParams();
  params.set("property_id", prefill.propertyId);
  if (prefill.partnerId) params.set("partner_id", prefill.partnerId);
  if (prefill.agencyName) params.set("agency_name", prefill.agencyName);
  params.set("prefill", "address");
  if (prefill.score) params.set("score", prefill.score);
  return `/plan?${params.toString()}`;
}

export async function recordCtaClick(token: string): Promise<boolean> {
  if (!token) return false;
  try {
    const res = await fetch(`${API_BASE}/api/widget/handoff/action`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, action: "cta_clicked" }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export function useEnergyPlanPrefill() {
  return {
    parseHandoffPrefill,
    buildQuoteUrl,
    recordCtaClick,
    looksLikeUprn,
  };
}
